var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRightIos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 9,
    viewBox: "0 0 5 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.497893 0.496641C0.223603 0.770931 0.22336 1.21557 0.497351 1.49016L3.1581 4.15671C3.19705 4.19575 3.19705 4.25894 3.1581 4.29798L0.497352 6.96453C0.223361 7.23912 0.223603 7.68376 0.497893 7.95805C0.772396 8.23255 1.21745 8.23255 1.49195 7.95805L4.51555 4.93445C4.90607 4.54393 4.90607 3.91076 4.51555 3.52024L1.49195 0.496641C1.21745 0.22214 0.772395 0.222139 0.497893 0.496641Z",
    fill: "#415276"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightIos);
export default __webpack_public_path__ + "static/media/arrow-right-ios.5daf6da2f8c0a820becdb668f7e59e9e.svg";
export { ForwardRef as ReactComponent };